import React, { useState } from "react";
import { connect } from "react-redux";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import "./../productCard.scss";
import axios from "axios";
// radio button dependencies
import Translated from "../../Translated/Translated";
import translator from "../../../utils/translator";

function ProductCardForEditProductGroup(props) {
	const {
		productIsInGroup,
		updateProductGroup,
		productGroupId,
		productName,
		sku,
		imageURL,
		vendorName,
		description,
		modelNumber,
		bullets,
		specsManual,
		selected_language,
	} = props;

	const selectedLanguage = selected_language || "en";

	const apiURL = process.env.REACT_APP_BACKEND_URL;

	const [open, setOpen] = useState(false);

	async function removeProductFromGroup() {
		try {
			axios.post(
				apiURL + "/settings/product-groups/delete-product-from-group",
				{
					productGroupId: parseInt(productGroupId),
					sku
				},
			);
			updateProductGroup();
		} catch (error) {}
	}

	async function addProductToGroup() {
		try {
			await axios.post(
				apiURL + "/settings/product-groups/add-product-to-group",
				{ productGroupId, sku },
			);
			updateProductGroup();
		} catch (error) {}
	}

	return (
		<React.Fragment>
			{productIsInGroup && (
				<Button
					id="set-price-close-button"
					color="primary"
					onClick={removeProductFromGroup}
					className="pg-card-delete"
				>
					<i class="fas fa-times fa-2x" aria-hidden="true" />
				</Button>
			)}
			<div>
				{!productIsInGroup && (
					<button
						onClick={addProductToGroup}
						type="button"
						class={
							"btn btn-outline-primary edit-product-group-button pg-card-add " + sku
						}
					>
						{translator("Product Group", "add_product")}
					</button>
				)}

				<Button
					style={{ padding: "0" }}
					className="pg-card-button"
					variant="outlined"
					color="primary"
					onClick={() => setOpen(true)}
				>
					<div class="card">
						<div class="product_card_img_wrapper">
							<img
								class="card-img-top"
								src={imageURL}
								alt="Card image cap"
							/>
						</div>

						<div class="card-body">
							<h5 class="card-title">{vendorName[selectedLanguage]}</h5>
							<p class="card-text">{sku}</p>
							<p class="card-text">{productName[selectedLanguage]}</p>
							<p class="card-text">{modelNumber[selectedLanguage]}</p>
						</div>
					</div>
				</Button>
				<Dialog open={open} onClose={() => setOpen(false)} aria-labelledby="form-dialog-title">
					<DialogTitle id="form-dialog-title set-price-dialog-header"></DialogTitle>
					<DialogContent>
						<DialogContentText
							style={{
								display: "grid",
								gridTemplateColumns: "auto auto auto"
							}}
						>
							<img
								class="productImage"
								src={imageURL}
							/>
							<p class="productInformation">
								{vendorName[selectedLanguage]}
								<br />
								<br />
								<b><Translated section="Product Shopping" label="description_label" />:</b>
								<br />
								{description[selectedLanguage]}
								<br />
								{modelNumber[selectedLanguage]}
								<br />
								<b><Translated section="Product Shopping" label="details_dialog_further_label" />:</b>
								<ul>
									{bullets[selectedLanguage].map((bullet) => (<li>{bullet}</li>))}
								</ul>
								{specsManual[selectedLanguage] && (
									<a
										class="notwhitelink"
										target="_blank"
										href={specsManual[selectedLanguage]}
									>
										<Translated section="Product Shopping" label="details_dialog_brochure_label" />
									</a>
								)}
							</p>

							<Button
								style={{
									height: "3em",
									width: "0em"
								}}
								id="set-price-close-button"
								onClick={() => setOpen(false)}
								color="primary"
							>
								<i class="fa fa-window-close fa-2x" aria-hidden="true" />
							</Button>
						</DialogContentText>
					</DialogContent>
				</Dialog>
			</div>
		</React.Fragment>
	);
}

const mapStateToProps = state => ({
	selected_language: state.selected_language,
});

export default connect(mapStateToProps)(ProductCardForEditProductGroup);
